export const contactFormTestId = "cdp-contact-form";
export const contactFormSubmitTestId = `${contactFormTestId}-submit`;
export const bottomContactOpenedFormTestId = "cdp-contact-bottom-page";
